'use strict';

class FleetsController {
  static $inject = ['FleetsService', '$scope', '$q'];
  FleetsService: any;
  query: any = {};
  order: any = {};
  onPagination: any;
  onReorder: any;
  whereName: string;
  fleets: any[] = [];
  fleetsCount: number = 0;

  constructor(FleetsService, $scope, $q) {
    Object.assign(this, {
      FleetsService,
      $scope,
      $q
    });

    this.query = {
      include: [],
      where: {},
      limit: 10,
      page: 1,
      order: 'name ASC'
    };

    this.getFleets();

    this.onPagination = () => {
      this.getFleets();
    };
  }

  async getFleets() {
    let qOpts = JSON.parse(JSON.stringify(this.query));
    if (this.whereName) {
      qOpts.where.name = {
        ilike: `%${this.whereName}%`
      };
    }

    const queryReady = this.FleetsService.getModels(qOpts).then(fleets => {
      this.fleets = fleets;
    });
    const countReady = this.FleetsService.getCount(qOpts).then(result => {
      this.fleetsCount = result.count;
    });
    return Promise.all([queryReady, countReady]);
  }
}

export default FleetsController;
